module.exports = require('./modules/components/DefaultRoute');



//////////////////
// WEBPACK FOOTER
// ./~/react-router/DefaultRoute.js
// module id = 184
// module chunks = 0